import type { AnchorHTMLAttributes, ReactNode } from 'react';

import SvgIcon from '@liquidweb-dev/undercurrent/SvgIcon';
import Typography, {
	TypographyProps,
} from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface NavLinkSubProps extends TypographyProps {
	active?: boolean;
	startIcon?: ReactNode;
	endIcon?: ReactNode;
	href?: AnchorHTMLAttributes<HTMLAnchorElement>['href'];
	target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
}

export function NavLinkSub({
	active,
	startIcon,
	endIcon,
	sx: sxProp,
	children,
	...rest
}: NavLinkSubProps) {
	return (
		<Typography
			component="a"
			sx={combineSx(
				(theme) => ({
					height: theme.size.md,
					overflow: 'hidden',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'stretch',
					color: theme.vars.palette.text.primary,
					textDecoration: 'none',
					paddingY: 100,
					paddingX: 150,
					borderRadius: theme.borderRadius.roundedSm,
					gap: 100,
					':hover': {
						backgroundColor: theme.vars.palette.uc.bg.weak,
						outline: 'none',
					},
					':active': {
						backgroundColor: theme.vars.palette.uc.bg.weak,
						outline: 'none',
					},
					':focus-visible': {
						outlineOffset: '2px',
						outlineWidth: '2px',
						outlineStyle: 'solid',
						outlineColor: theme.vars.palette.uc.highlight.border.main,
					},
					[theme.breakpoints.down('sm')]: {
						padding: 200,
						height: theme.size.xL,
					},
					...(active && {
						backgroundColor: theme.vars.palette.uc.bg.weak,
						outline: 'none',
					}),
				}),
				sxProp,
			)}
			{...rest}
		>
			{startIcon && (
				<SvgIcon sx={{ height: '16px', width: '16px' }}>{startIcon}</SvgIcon>
			)}
			<Typography
				component="span"
				variant="label-lg"
				display="block"
				flex="0% 1 1"
				whiteSpace="nowrap"
			>
				{children}
			</Typography>
			{endIcon && (
				<SvgIcon sx={{ height: '16px', width: '16px' }}>{endIcon}</SvgIcon>
			)}
		</Typography>
	);
}
export default NavLinkSub;
